import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material';
import { NamePromptModalComponent, NamePromptModel } from '../AppBaseComponents/name-prompt-modal/name-prompt-modal.component';

// Thin wrapper around the app's existing MatDialog pattern (see
// AppBaseComponents/dialog) so every "name this step" / "rename step"
// prompt across the Web Recorder feature opens the same modal instead of
// each component building its own.
@Injectable({ providedIn: 'root' })
export class NamePromptService {

  constructor(private dialog: MatDialog) {}

  open(title: string, initialValue: string, confirmLabel = 'Save'): Promise<string | null> {
    const dialogRef = this.dialog.open(NamePromptModalComponent, {
      data: new NamePromptModel(title, initialValue, confirmLabel)
    });
    return dialogRef.afterClosed().toPromise().then(result => result || null);
  }
}
